'use client';

import { setFormModal } from '@/lib/RTK/features/AdmissionSlice';
import { useAppDispatch, useAppSelector } from '@/lib/RTK/hooks'; 
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import BtnSendFormModal from '../admission/BtnSendFormModal';
import FormLoginModal from '../admission/FormLoginModal';
import {
    set_lab_id,
    setNameLab_radio,
} from '@/lib/RTK/features/Single_labSlice'; 
import { FaAngleLeft } from 'react-icons/fa';
import { Button } from '@/components/ui/button';

export default function SetButtonId({
    id,
    name,
}: {
    id: number;
    name: string;
}) {
    const dispatch = useAppDispatch();
    const router = useRouter();
    const pathName = usePathname();

    const psistionModal = useAppSelector((s) => s.admission.position);
    const token = useAppSelector((state) => state.auth_token_slice.token);
    const [open, setOpen] = useState(false);

    function handleSetId(id: number) {
        dispatch(set_lab_id(id));
        if (!token || token === 'undefined') {
            setOpen(true);
            return true;
        } else {
            dispatch(setNameLab_radio(name));
            router.push(`${pathName}/turn`);
        }
    }

    function handleResetPosition() {
        dispatch(setFormModal(''));
    }

    function checkStatus() {
        if (!token || token === 'undefined') {
            setOpen(false);
            return true;
        } else {
            setOpen(true);
        }
    }

    useEffect(() => {
        checkStatus();
    }, [token]);

    return (
        <>
            {!open && (
                <>
                    {psistionModal === '' && (
                        <BtnSendFormModal
                            handleResetPosition={handleResetPosition}
                            enableSubmit={true}
                            textBtn={true}
                            useLab_imaging={true}
                        />
                    )}
                    {psistionModal === 'formlogin' && (
                        <FormLoginModal
                            handleResetPosition={handleResetPosition}
                            enableSubmit={true}
                            textBtn={true}
                            pathNameRoute={`${pathName}/turn`}
                            nameLabRadio={name}
                        />
                    )}
                </> 
            )}
            {open && (
                <Button
                    className="smp:!w-max w-full !bg-blue hover:!bg-blue text-white !h-10 items-center smp:!mt-0 mt-4 !rounded-2xl hover:!opacity-75 transition-opacity text-sm smp:!text-base !flex gap-1 !px-8"
                    onClick={() => handleSetId(id)}
                >
                    درخواست نوبت
                    <FaAngleLeft className="text-white" />
                </Button>
            )}
        </>
    );
}
